export const SURVEY_KEY = process.env.NEXT_PUBLIC_SURVEY_KEY || 'survey-alpha';
export const SURVEY_ONBOARDING_KEY =
  process.env.NEXT_PUBLIC_SURVEY_ONBOARDING_KEY || 'survey-onboarding';
export const SURVEY_ONBOARDING_GIFTED_KEY =
  process.env.SURVEY_ONBOARDING_GIFTED_KEY || 'survey-registered-test-kit-onboarding';
export const SESSION_STORAGE_KEY = 'tally-survey';
